import React, { useEffect, useState } from "react";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck } from "utils/columns";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  Button,
} from "reactstrap";
import ErrorBoundary from "components/ErrorBoundary";

import Top10DrugUtilizationDrawer from "pages/ClientDashBoard/Components/GridData/GridReports/Top10DrugUtilizationDrawer";
import Drawer from "components/Drawer";
const UtilizationPMPM = ({ utilizationPmpm, dateRange, planId, groupId, startDate,endDate,rebatechecked }) => {
  const [summaryData, setSummaryData] = useState([]);
  const [disabledViewButtom, setDisabledViewButtom] = useState(true);
     const [isOpen, setIsOpen] = useState(false);
  const handleProceed = () => {
    setIsOpen(!isOpen);
  };
  const Top10DrugClassbyUtilizationColumns = [
    {
      dataField: "drugName",
      text: "Drug Class",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (utilizationPmpm) =>
        cellRendererCheck(utilizationPmpm.drugName),
    },
    {
      dataField: "count",
      text: "Rx Count",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (utilizationPmpm) =>
        cellRendererCheck(utilizationPmpm.count),
    },
  ];
const onHandleIsOpen = (hasRefresh)=> {
      
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
      }
   useEffect(() => {
     if (utilizationPmpm && utilizationPmpm.length > 0) {
       setDisabledViewButtom(false);
     } else {
       setDisabledViewButtom(true);
     }
   }, [utilizationPmpm]);



  return (
    <ErrorBoundary>
    <Card className="p-3 h-100">
      <CardHeader className="border-0 bg-white px-0 pt-0">
        <Row className="align-items-center">
          <Col>
            <CardTitle className="f-20 font-weight-500">
              Top 10 Drug Classes - By Utilization
            </CardTitle>
          </Col>
        </Row>
      </CardHeader>

      <CardBody className="dashboard-chart-body">
        <div
          className={`table-card scroll-table position-relative border-0 rounded pt-0 scroll ${
            utilizationPmpm?.length > 0 ? "fixed-height" : "default"
          }`}
        >
          <ReactStrapTable
            columns={Top10DrugClassbyUtilizationColumns}
            data={utilizationPmpm}
          />
        </div>
        <div className="view-report">
          <Button
            color="primary"
            className="ms-2"
            onClick={handleProceed}
            style={{ float: "right", marginTop: "26px" }}
            disabled={disabledViewButtom}
          >
            View Report
          </Button>
        </div>
      </CardBody>
    </Card>
        <Drawer
                direction='end'
                title='Top 10 Drug Classes - By Utilization'
                isOpen={isOpen}
                toggle={handleProceed}
                size="lg"
                   disabled={disabledViewButtom}
                        
            >
<Top10DrugUtilizationDrawer  dateRange={dateRange} planId={planId} groupId={groupId} startDate={startDate} endDate={endDate} rebatechecked={rebatechecked} onHandleIsOpen={onHandleIsOpen}  />
            </Drawer> 

    
    </ErrorBoundary>
  );
};

export default UtilizationPMPM;
